<template>
	<section ref="sectionRef"
			 class="flex-module container-fluid flexible-herotext">
		<component :is="el"
				   ref="titleRef"
				   class="hero-title">
			{{ text }}
		</component>
	</section>
</template>

<script setup>
import debounceFn from 'debounce-fn'

const props = defineProps({
	data: {
		type: [Object, String],
		required: true
	},
	delay: {
		type: [Number, String],
		default: null
	},
	el: {
		type: String,
		default: 'h1'
	}
})

const { gsap, ScrollTrigger, SplitText } = useGsap()
const { $bus } = useNuxtApp()
const metaStore = useMetaStore()

const sectionRef = ref(null)
const titleRef = ref(null)

const splitlines = reactive({})
const revealDelay = props.delay ? Number(props.delay) : props.data?.delay ? Number(props.data.delay) : metaStore.transitionDuration ? metaStore.getDelay : 500
const triggers = {}
let $q


const text = computed(() => { return props.data.item?.title || props.data.item?.text || props.data.toString() || '' })

function animRevealTitle() {
	if (Object.prototype.hasOwnProperty.call(splitlines, 'innerSplit')) {
		revertText()
	}

	document.fonts.ready.then(() => {
		splitlines.outerSplit = new SplitText(titleRef.value, {
			type: 'lines',
			linesClass: 'split-parent'
		})

		splitlines.innerSplit = new SplitText($q('.split-parent'), {
			type: 'lines',
			linesClass: 'split-child'
		})

		gsap.set($q('.split-parent'), {
			overflow: 'hidden',
			position: 'relative',
		})

		gsap.set($q('.split-child'), {
			yPercent: 100,
		})

		gsap.set($q('.hero-title'), {
			autoAlpha: 1
		})

		delay(revealDelay).then(() => {
			triggers.revealTitle = ScrollTrigger.create({
				id: 'animRevealTitle',
				trigger: sectionRef.value,
				start: 'top bottom',
				onEnter: () => {
					gsap.to(splitlines.innerSplit.lines, {
						yPercent: 0,
						duration: 1.5,
						stagger: 0.2,
						ease: 'expo.out',
						onComplete: () => {
							// console.log('animRevealTitle complete')
							revertText()
							triggers.revealTitle.kill()
							delete triggers.revealTitle
						}
					})
				}
			})
		})
	})
}

const revertText = debounceFn((safe) => {
	nextTick(() => {
		splitlines.outerSplit.revert()
		splitlines.innerSplit.revert()
	})
}, { wait: 100 })


function initAnims() {
	$q = gsap.utils.selector(sectionRef.value)

	animRevealTitle()
}

onMounted(() => {
	useAnims(initAnims, triggers)

	$bus.$on('window-resized', revertText)
})

onBeforeUnmount(() => {
	$bus.$off('window-resized', revertText)
})
</script>

<style lang="scss" scoped>
.hero-title {
	@include textH1;
	line-height: 1.3;
	visibility: hidden;

	.split-parent {
		overflow: hidden;
		position: relative;

		.split-child {
			transform: translate(0px, 100%);
		}
	}
}
</style>